"use strict";

import 'url-search-params-polyfill'; // Edge Polyfill
import 'whatwg-fetch'; // IE10 Polyfill

export function initInScope ($scope) {
    let containers = $scope[0].querySelectorAll('.js-threeSixty');

    if (!containers.length) {
        return;
    }

    let pendingRequest;

    containers.forEach(function (container) {
        let $container = $(container);
        let url = $container.data('image-url');

        if (!url) {
            console.warn('data-image-url missing for js-threeSixty', container);
            return;
        }

        pendingRequest = fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With' : 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            }
        }).then((res) => {
            return res.json()
        }).then((res) => {

            pendingRequest = null;
            if (res.success) {
                let images = res.images;

                import('@mladenilic/threesixty.js').then((ThreeSixty) =>{
                    ThreeSixty = ThreeSixty.default;

                    if($container.hasClass('threeSixty--Iframe')) {
                        /* 360 in iframe with image preloading */
                        Promise.all(images.map((src) => {
                            return new Promise((resolve, reject) => {
                                const image = new Image();

                                image.onload = resolve;
                                image.onerror = resolve;

                                image.style.display = 'none';
                                image.src = src;

                                document.body.appendChild(image);
                            })
                        }));
                        const threesixty = new ThreeSixty(document.getElementById('js-threeSixty'), {
                            image: images,
                            inverted: true,
                            width: $container.width(),
                            height: $container.height(),
                            dragTolerance: 20,  // Rotation speed when dragging. Default: 10
                            swipeTolerance: 20, // Rotation speed when swiping. Default: 10
                        });
                    }

                    $container.one('mousedown touchstart', function () {
                        $('.js-threeSixty__info').attr('hidden', true);
                    });

                    // change cursor on mousedown
                    $container.on('mousedown', function (evt) {
                        $(this).addClass('mousedown')
                    }).on('mouseup', function () {
                        $(this).removeClass('mousedown');
                    });

                });

            }
        }).catch((error) => {
            console.error("loading data-action failed:" + error);
        });

    });
}